var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemTimelines = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M3 7a1 1 0 1 1 0-2h18a1 1 0 1 1 0 2Zm-.143 4C2.383 11 2 10.553 2 10s.383-1 .857-1h10.286c.474 0 .857.447.857 1s-.383 1-.857 1Zm14.147 0a1 1 0 1 1 0-2H21a1 1 0 1 1 0 2ZM3 15a1 1 0 1 1 0-2h18a1 1 0 1 1 0 2Zm8 4a1 1 0 1 1 0-2h10a1 1 0 1 1 0 2Zm-8 0a1 1 0 1 1 0-2h4a1 1 0 1 1 0 2Z"
})));
export default SvgGemTimelines;